import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { ReturnPolicy } from '../../models/warranty-type/warranty-model';
import { ProductService } from '../../services/product/product.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-return-policy-edit',
    templateUrl: './return-policy-edit.component.html',
    styleUrls: ['./return-policy-edit.component.css']
})
/** return-policy-edit component*/
export class ReturnPolicyEditComponent {
  /** return-policy-edit ctor */
  public returnPolicy = new ReturnPolicy();
  validate: boolean;
  constructor(private readonly productService: ProductService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService, private _avRoute: ActivatedRoute) {
    this.rolePermissionService.GetRolePermissions("returnPolicy").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            if (this._avRoute.snapshot.params["id"]) {
              this.getReturnPolicyById(this._avRoute.snapshot.params["id"]);
              this.toastr.setRootViewContainerRef(vcr);
            }
            this.validate = true;

          }
          else {
            this.router.navigate(["/warranty-list"]);
          }
        }
        else {
          this.router.navigate(["/warranty-list"]);
        }
      }
    )

  }
  getReturnPolicyById(id: string) {
    this.productService.getReturnPolicyById(id).subscribe(
      data => {
        this.returnPolicy = data;
      }
    )
  }
  isActiveCheckbox(e) {
    this.returnPolicy.isActive = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.productService.updateReturnPolicy(this.returnPolicy).subscribe(result => {
      if (result) {
        this.toastr.success('Return Policy has been Update.', 'Success');
        setTimeout(() => {
          this.router.navigate(["/returnPolicy-list"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Please try again', 'Error');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/return-policy/return-policy-edit/return-policy-edit.component.ts